import { render, staticRenderFns } from "./CircleChart.vue?vue&type=template&id=1c49b4d4&scoped=true&"
import script from "./CircleChart.vue?vue&type=script&lang=js&"
export * from "./CircleChart.vue?vue&type=script&lang=js&"
import style0 from "./CircleChart.vue?vue&type=style&index=0&id=1c49b4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c49b4d4",
  null
  
)

component.options.__file = "CircleChart.vue"
export default component.exports